type Item = {
  id: string
  productId?: string
  quantity: number
  price: number
}

type ItemToAdd = {
  id: string
  quantity: number
  price: number
  productId?: string
}
type CartItem = { id: string; quantity: number; price: string }

export function sanitizePrice(price: string): number {
  return Number(price.replace(/\D/g, '')) / 100 || 0
}

function mergeCartItems(
  baseCart: CartItem[] | null | undefined,
  itemsToAdd: ItemToAdd[]
): Item[] {
  const sanitizedCart = (baseCart ?? []).map((item) => ({
    ...item,
    price: sanitizePrice(item.price),
  }))

  return [...sanitizedCart, ...itemsToAdd]
}

/**
 * Builds a list of "Add To Cart" events formatted for Dynamic Yield,
 * including both existing and newly added cart items.
 *
 * @param {Object} params - The function parameters.
 * @param {ItemToAdd[]} params.itemsToAdd - Items being added to the cart.
 * @param {CartItem[] | null | undefined} params.cartItems - Existing items in the cart (treated as empty when absent).
 * @returns {Array} An array of "Add To Cart" event objects formatted for Dynamic Yield.
 */
export default function buildAddToCartObject({
  itemsToAdd,
  cartItems,
}: {
  itemsToAdd: ItemToAdd[]
  cartItems: CartItem[] | null | undefined
}) {
  const fullCart = mergeCartItems(cartItems, itemsToAdd)

  return itemsToAdd.map((item) => ({
    name: 'Add To Cart' as const,
    properties: {
      quantity: item.quantity,
      currency: 'BRL',
      productId: item?.id,
      dyType: 'add-to-cart-v1' as const,
      value: item.price,
      cart: fullCart.map((cartItem) => ({
        itemPrice: cartItem.price,
        productId: cartItem.id,
        quantity: cartItem.quantity,
      })),
    },
  }))
}
